import { z } from 'zod';
import { QUOTATION_RECURRING_TYPE_OPTIONS } from './quotationFormConstants';

const recurringTypeEnum = z.enum(
  QUOTATION_RECURRING_TYPE_OPTIONS.map((o) => o.value) as [
    (typeof QUOTATION_RECURRING_TYPE_OPTIONS)[number]['value'],
    ...(typeof QUOTATION_RECURRING_TYPE_OPTIONS)[number]['value'][],
  ],
);

export const quotationFormGroupRowSchema = z.object({
  key: z.string(),
  documentId: z.string().optional(),
  customer: z
    .object({
      documentId: z.string(),
      customer_number: z.string(),
      name: z.string(),
    })
    .passthrough()
    .nullable(),
  recurring_type: z.union([recurringTypeEnum, z.literal('')]),
  recurring_interval: z.string(),
  recurring_count_override: z.string(),
  recurring_start_date: z.string(),
  sampleRows: z.array(
    z.object({
      key: z.string(),
      documentId: z.string().optional(),
      jenisPengukuranMasterId: z.string(),
      jenisPengukuranLabel: z.string().optional(),
      parameterUji: z.string(),
      bakuMutuMasterId: z.string(),
      bakuMutuLabel: z.string().optional(),
      jumlahTitik: z.string(),
      harga: z.string(),
    }),
  ),
  otherCostRows: z.array(
    z.object({
      key: z.string(),
      documentId: z.string().optional(),
      description: z.string(),
      quantity: z.string(),
      cost_price: z.string(),
    }),
  ),
});
